import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component GroupByIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <GroupByIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <GroupByIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const GroupByIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="GroupByIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M20.598 9a1 1 0 0 1-1.994-.123V5.392h-3.486a.997.997 0 1 1 0-1.995l4.486-.005.118.007a1 1 0 0 1 .883.993v4.49l-.007.12zM5.396 15.122v3.487h3.486a.998.998 0 0 1 0 1.995l-4.486.005-.118-.007a1 1 0 0 1-.883-.993v-4.49l.007-.12a.997.997 0 0 1 .993-.877l.12.008a1 1 0 0 1 .881.992m8.726 4.478a1 1 0 0 0 .878.998l.12.008h4.489a1 1 0 0 0 .993-.884l.007-.118-.005-4.486a.998.998 0 0 0-1.995 0v3.486h-3.487a1 1 0 0 0-1 .996M5.391 5.396h3.487a1 1 0 0 0 .992-.88l.008-.12A.997.997 0 0 0 9 3.401l-.12-.008H4.392a1 1 0 0 0-.993.884l-.007.118.005 4.486a.998.998 0 0 0 1.995 0V5.396zM8 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1 2a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2zm-1 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1" />
    </svg>
  )
);
GroupByIcon.displayName = "GroupByIcon";
export default GroupByIcon;
